// extracted by mini-css-extract-plugin
module.exports = {"input":"_1oAXNYb1WL7U0r7eWLNhih"};